import { render, staticRenderFns } from "./JpmeContratC5.vue?vue&type=template&id=72f98e39&"
import script from "./JpmeContratC5.vue?vue&type=script&lang=js&"
export * from "./JpmeContratC5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports